import React from "react";

// Slug and Worm, the two of us, in the same pixel style as the avatars:
// a Pacific Northwest banana slug and a little pink worm in a trans-flag
// scarf, with a letter between them.
const PALETTE: Record<string, string> = {
  o: "#24170f", // outline
  y: "#ffd84d", // banana slug
  Y: "#d9a400", // slug spots and underside
  k: "#f59ab0", // worm
  K: "#c94f71", // worm segments, blush
  b: "#5bcefa", // scarf blue
  p: "#f5a9b8", // scarf pink
  w: "#ffffff",
};

const SLUG = [
  "................",
  "................",
  "..........o...o.",
  "..........y...y.",
  "..........y...y.",
  "..........y...y.",
  ".........oyyyyyo",
  "........oyyyyyyo",
  "........oyyyyoyo",
  "....oooyyyyyyKyo",
  "..ooyyyyyyyyyyyo",
  ".oyyYyyyYyyyyyyo",
  "oyyyyyyyYyyyyyo.",
  "oYYYYYYYYYYYYYo.",
  ".ooooooooooooo..",
  "................",
];

const WORM = [
  "................",
  "................",
  "................",
  "....oooo........",
  "...okkkko.......",
  "...okokko.......",
  "...okkkKo.......",
  "...obbbbob......",
  "...oppppo.b.....",
  "....okkkko......",
  ".....okkkko.....",
  "......okKkko....",
  ".....okkkko.....",
  "....okkkKo......",
  "....oooooo......",
  "................",
];

const LETTER = [
  "oooooooooo",
  "oowwwwwwoo",
  "owowwwwowo",
  "owwowwowwo",
  "owwwKKwwwo",
  "owwwwwwwwo",
  "oooooooooo",
];

function Pixels({ rows, scale, flip }: { rows: string[]; scale: number; flip?: boolean }) {
  const w = rows[0].length;
  const h = rows.length;
  return (
    <svg
      width={w * scale}
      height={h * scale}
      viewBox={`0 0 ${w} ${h}`}
      shapeRendering="crispEdges"
      style={flip ? { transform: "scaleX(-1)" } : undefined}
      aria-hidden="true"
    >
      {rows.flatMap((row, y) =>
        [...row].map((c, x) =>
          PALETTE[c] ? <rect key={`${x}-${y}`} x={x} y={y} width={1.02} height={1.02} fill={PALETTE[c]} /> : null
        )
      )}
    </svg>
  );
}

export default function SlugAndWorm({ scale = 4 }: { scale?: number }) {
  return (
    <span className="inline-flex items-end gap-1" role="img" aria-label="Slug and Worm, with a letter">
      <Pixels rows={SLUG} scale={scale} />
      <span style={{ paddingBottom: scale * 2 }}>
        <Pixels rows={LETTER} scale={scale} />
      </span>
      <Pixels rows={WORM} scale={scale} />
    </span>
  );
}
